import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.RESET_LOGIN](state) {
    state.solution = null
    state.language = ''
    state.isLogout = true
    state.roles = []
    state.token = null
    state.username = null
    state.userProfile = {
      id: null,
      location: {},
      firstName: '',
      lastName: '',
      userName: '',
      email: '',
      phone: '',
      isNew: true,
      contact: null
    }
    state.fullUserData = null
    state.demoMode = false
    state.userIsMahle = false
    state.userToken = null
    state.unreadCount = 0
  },

  [types.RESET_MAHLE_COIN_BALANCE](state) {
    state.mahleCoinBalance = 0
  },

  [types.RESET_USER_ISMAHLE](state) {
    state.userIsMahle = false
  },

  [types.RESET_MAHLE_DIAGNOSTIC_LICENSE_STATUS](state) {
    state.mahleDiagnosticLicenseStatus = ''
  },

  [types.RESET_MAHLE_API_ERROR_MSG](state) {
    state.mahleApiErrorMsg = ''
  },

  [types.SET_MAHLE_COIN_COUNT](state, coinCount) {
    state.mahleCoinBalance = coinCount ?? 0
  },

  [types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS](state, status) {
    state.mahleDiagnosticLicenseStatus = status ?? ''
  },

  [types.SET_MAHLE_API_ERROR_MSG](state, msg) {
    state.mahleApiErrorMsg = msg ?? ''
  },

  [types.SET_USER_ISMAHLE](state, isMahle) {
    state.userIsMahle = Boolean(isMahle)
  },

  [types.SET_DEMO_MODE](state, demoMode) {
    state.demoMode = !!demoMode
  },

  [types.SET_USER_INFO](state, info) {
    if (!info) return
    state.userInfo = { ...info }
    state.language = info.language || state.language
  },

  [types.SET_TOKEN](state, token) {
    state.token = token ?? null
  },

  [types.SET_SOLUTION](state, solution) {
    state.solution = solution ?? 1
  },
  [types.SET_CHAT_AS](state, payload) {
    state.chatAs = payload || null
  },
  [types.SET_ROLES](state, payload) {
    const roles = Array.isArray(payload)
      ? payload.map(r => (typeof r === 'string' ? r : String(r || ''))).filter(Boolean)
      : []

    state.roles = roles

    // Derive primaryRole (kept from your original logic)
    state.primaryRole = ''
    for (const role of roles) {
      if (['InShopTech', 'DiagCoord'].includes(role)) { state.primaryRole = 'Tech'; break }
      if (role === 'MasterTech') { state.primaryRole = 'MasterTech'; break }
      if (role === 'Dispatch') { state.primaryRole = 'Dispatch'; break }
    }
    if (!state.primaryRole && roles.length) state.primaryRole = roles[0]
  },

  [types.SET_PASSTHROUGH](state, passthrough) {
    state.passthrough = passthrough ?? null
  },

  [types.SET_USER_PROFILE](state, data) {
    state.userProfile = data || {
      id: null,
      location: {},
      firstName: '',
      lastName: '',
      userName: '',
      email: '',
      phone: '',
      isNew: true,
      contact: null
    }
  },

  [types.SET_PRIMARY_ROLE](state, data) {
    state.primaryRole = data || ''
  },

  [types.SET_USER_TOKEN](state, data) {
    state.userToken = data || null
  },

  [types.SET_LOCATION_KEY](state, data) {
    if (state.userProfile?.location) {
      state.userProfile.location.key = data?.sid || null
      state.userProfile.location.isHunterClient = !!data?.isHunterClient
      state.userProfile.location.useConnect = data?.useConnect === true
    } else {
      state.userProfile.location = {
        key: data?.sid || null,
        isHunterClient: !!data?.isHunterClient,
        useConnect: data?.useConnect === true
      }
    }
  },

  [types.SET_BUSINESS_USERS](state, data) {
    state.businessUsers = (data || [])
      .filter(u => u.id !== null && u.isAstechUser)
      .map(u => ({
        value: u.id,
        name: `${u.firstName} ${u.lastName}`
      }))
  },

  [types.SET_CONTACT](state, id) {
    if (state.userProfile) {
      // keep the logged-in identity intact; just track the chosen contactId
      state.userProfile = {
        ...state.userProfile,
        contactId: id
      }
    }
  },

  [types.SET_CONTACT_ID](state, id) {
    if (state.userProfile) {
      state.userProfile.contactId = id
    }
  },

  [types.SET_USERINFO](state, userInfo) {
    if (!userInfo) return
    // keep logged-in profile untouched
    state.userInfo = { ...userInfo }
  },

  [types.SET_PHONE](state, phone) {
    if (state.userProfile) {
      state.userProfile.phone = phone
    }
  },

  [types.UPDATE_CONTACT](state, data) {
    if (state.userProfile) {
      Object.assign(state.userProfile, {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
        isNew: false,
        contact: data.contact
      })
      state.userToken = {
        id: data.contact,
        token: data.email
      }
    }
  },

  [types.SET_LANGUAGE](state, language) {
    state.language = language || state.language
    if (state.userProfile) {
      state.userProfile.language = language
    }
    if (state.userInfo) {
      state.userInfo.language = language
    }
  },

  [types.SHOW_LOGGING](state, isShow) {
    state.showLog = !!isShow
  },

  [types.SET_LOGGING](state, data) {
    state.isLogging = !!data
  },

  [types.SET_LOG_ENTRY](state, data) {
    const date = new Date()
    const hours = date.getHours() % 12 || 12
    const minutes = `${date.getMinutes()}`.padStart(2, '0')
    const ampm = date.getHours() >= 12 ? 'pm' : 'am'
    data.time = `${hours}:${minutes} ${ampm}`

    if (data.isSystem) {
      const lastId = state.systemLog[state.systemLog.length - 1]?.id || 1000
      data.id = lastId + 1
      state.systemLog.push(data)
    }

    if (state.isLogging) {
      if (state.log.length > 100) {
        state.log = state.systemLog.concat(state.log.slice(-100))
      }
      data.id = state.log.length + 1
      state.log.push(data)
    }
  },

  [types.CLEAR_LOG](state) {
    state.log = state.systemLog.concat([
      {
        id: 0,
        component: 'main',
        method: 'init',
        text: 'starting log'
      }
    ])
  },

  [types.SET_NOTIFICATION_TOKEN](state, token) {
    state.notificationToken = token || ''
  },

  [types.SET_TERMANDCONDITIONS_UI_MESSAGE](state, message) {
    state.termAndConditionsUIMessage = message || ''
  },
  [types.SET_USER_RAG_ONLY](state, isRagOnly) {
    state.isRagOnly = isRagOnly
    storage.local.setItem(types.SESSION_RAG_ONLY, isRagOnly?.toString())
  },
  [types.SET_USER_SHOW_RAG](state, showRag) {
    state.showRag = showRag
    storage.local.setItem(types.SESSION_SHOW_RAG, showRag?.toString())
  },
  [types.SET_FULL_USER_DATA](state, userData) {
    state.fullUserData = userData
    storage.local.setItem(types.SESSION_FULL_USER_DATA, JSON.stringify(userData))

    console.log('Stored in state.fullUserData:', state.fullUserData)
    console.log('state.fullUserData.Language:', state.fullUserData.Language)
    console.log('=====================================')
  },

  [types.SET_AUTH_INITIALIZED](state, initialized) {
    state.authInitialized = initialized
  },

  [types.SET_APP_BOOTSTRAPPED](state, isBootstrapped) {
    state.bootstrapped = isBootstrapped

    // Save to local storage
    try {
      storage.local.setItem(types.BOOTSTRAPPED, isBootstrapped)
    } catch (e) {
      console.warn('Failed to write APP_BOOTSTRAPPED to local storage:', e)
    }
  }
}
